<template>
  <div class="chooseExport">
    <div class="chooseExport__header">
      <p class="chooseExport__title font-weight-bold mb-1 text-gray-base">
        {{ title }}
      </p>
    </div>
    <div class="chooseExport__body my-2">
      <div>
        <p class="chooseExport__description text-gray-700">{{ $t('choose-export.title') }}</p>
      </div>
      <div class="d-flex flex-column">
        <CButton class="btn-choose" :class="{ 'btn-choose--active': typeFileExport == 'csv' }" @click="typeFileExport = 'csv'">.CSV</CButton>
        <CButton v-show="blockXls" class="btn-choose" :class="{ 'btn-choose--active': typeFileExport == 'xls' }" @click="typeFileExport = 'xls'"
          >.XLS</CButton
        >
      </div>
      <div v-if="typeFileExport == 'csv'" class="my-2">
        <p class="chooseExport__description text-gray-700">{{ $t('choose-export.csv.chars-type') }}</p>
        <div>
          <TypeDemiliterCSVExport @delimiterValue="delimiterValue" />
          <!-- <CSelect
            :options="[
              { label: 'SemiColon', value: ';' },
              { label: 'Comma', value: ',' },
              { label: 'Other', value: true },
            ]"
            :checked.sync="cvsCharacters"
            :value.sync="cvsCharacters"
          >
          </CSelect>

          <CInput
            v-if="cvsCharacters === true"
            value="otherCharacters"
          /> -->
        </div>
      </div>
    </div>
    <div class="chooseExport__footer mt-3">
      <div class="d-flex">
        <CButton class="chooseExport__btn btn btn-primary" :disabled="isDisabled || isLoadingConfirm" @click="confirm">
          <div class="d-flex align-items-center">
            <span>{{ $t('choose-export.btn.confirm') }}</span>
            <CSpinner class="ml-2" v-if="isLoadingConfirm" color="primary" style="width: 1rem; height: 1rem" />
          </div>
        </CButton>
        <CButton class="chooseExport__btn" @click="cancel" type="link"> {{ $t('choose-export.btn.cancel') }} </CButton>
      </div>
    </div>
  </div>
</template>

<script>
import TypeDemiliterCSVExport from './TypeDemiliterCSVExport.vue'

export default {
  components: { TypeDemiliterCSVExport },
  name: 'ChooseExport',
  props: {
    totalRecords: {
      type: Number,
      required: false,
      default: 0,
    },
    title: {
      type: String,
    },
    isLoadingConfirm: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data() {
    return {
      typeFileExport: null,
      cvsCharacters: ';',
      limiteXlS: 2000000,
    }
  },
  computed: {
    blockXls() {
      return this.totalRecords <= this.limiteXlS
    },

    isDisabled() {
      if (this.typeFileExport === 'xls') {
        return false
      }

      if (this.typeFileExport === 'csv' && this.cvsCharacters !== '') {
        return false
      }

      return true
    },
  },
  methods: {
    handler() {
      return {
        format: this.typeFileExport === 'xls' ? 1 : 2,
        delimiter: this.typeFileExport === 'xls' ? null : this.cvsCharacters,
      }
    },

    confirm() {
      this.$emit('confirm', this.handler())
    },

    cancel() {
      this.$emit('cancel')
    },

    delimiterValue(char) {
      this.cvsCharacters = char
    },
  },
}
</script>

<style lang="scss" scoped>
.btn-choose {
  text-align: left;
  font-weight: normal;
  color: $gray-600;
  &:hover,
  &--active {
    font-weight: $font-weight-semi-bold;
    background-color: transparentize($primary, 0.75);
    color: $gray-700;
  }
}
</style>
